import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69b1f738886e100014e91595/hkbeiyu/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b1f738886e100014e91595/hkbeiyu/src/components/Header.tsx");
